module.exports = __webpack_public_path__ + "static/media/bottom3.15383dd6.jpg";